
    import {
      withCompInfo,
      createComponentMapperModel,
    } from '@wix/editor-elements-integrations';

    const props = withCompInfo<any, any>()(
      ['compData'],
      ({ compData }) => {
        return {
          ...{"charactersLimit":100,"selectedOnFocus":true,"autofocus":false,"readOnly":false,"prefix":"","placeholder":"Placeholder text","defaultText":"Write it here...","tooltipInfo":"","fieldTitle":"Text Input"},
          ...compData,
          
        };
      },
    );

    export default createComponentMapperModel({
      props,
    });
  